export type HookSYSLoginSuccess_Type = {
  isRelogin: boolean
}
export const HookSYSLoginSuccess = "HookSYSLoginSuccess"
